/**
 * Classe que gerencia os Eventos de Mapa
 *
 * @author: Adalto Junior DATE: 10/05/2012
 */


Greenmile.HoursOfService = Greenmile.HoursOfService || {};
Greenmile.HoursOfService.MapEvents = function (selector) {

    var getContentPopup = function (event) {

        try {


            if (event.eventTime) {

                var eventTime = Monet.Format.DateTime.formatToLocale(event.eventTime);
                var eventType = Monet.I18n.getResourcesByKey(Greenmile.HoursOfService.Utils.getResourceByEventType(event.eventType));
                var label = Monet.I18n.getResourcesByKey("Greenmile.HOSMap.popup.label.eventTime");
                var eventTypeLabel = Monet.I18n.getResourcesByKey("Greenmile.HOSMap.popup.label.eventType");

                return '<div class="popupMapHOS">' +
                    '<div class="stopDetailWindow">' +
                    '<div class="windowLabel">' + eventTypeLabel + '</div>' +
                    '<div class="windowContent">' + eventType + '</div>' +
                    '</div>' +
                    '<div class="stopDetailWindow">' +
                    '<div class="windowLabel">' + label + '</div>' +
                    '<div class="windowContent">' + eventTime + '</div>' +
                    '</div>' +
                    '</div>';

            }

        } catch (e) {
            (new Monet.Exception.ReturnError(this, "Error on get content popup", e)).console();
        }
    };

    var getIconMarker = function (classNameMarker) {

        var error = null;

        try {

            var point       = new L.Point(35, 20),
                markerClass = "marker";

            markerClass += " " + classNameMarker;

            L.HoursOfService = L.Icon.extend({

                options: {
                    shadowUrl: null,
                    iconAnchor: new L.Point(11, 2),
                    popupAnchor: point,
                    className: ''
                },

                createIcon: function () {

                    var div      = document.createElement('div'),
                        divChild = document.createElement('div');

                    divChild.setAttribute("class", markerClass);

                    div.innerHTML = divChild.outerHTML;

                    this._setIconStyles(div, 'icon');

                    return div;
                },

                createShadow: function () {
                    return null;
                }
            });

            return new L.HoursOfService();

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on get icon marker");
            error.console();
        }

    };

    var drawMarker = function (event, map, hosType) {

        var latitude,
            longitude,
            eventType   = "",
            accuracy,
            radiusLayer = null,
            layerControl,
            contentPopup,
            utils       = Greenmile.HoursOfService.Utils,
            point       = new L.Point(2, -5);

        layerControl = new Greenmile.Toolbar.Map.HOSLayerControl(selector + ' #mapCon', map);

        if (hosType) {

            eventType = hosType;

        } else {

            eventType = utils.getEventTypeName(event.eventType);

        }

        layerControl.checkEventTypeLayer(event);

        latitude = event.latitude;
        longitude = event.longitude;

        accuracy = event.accuracyMeters;

        var marker = L.marker([latitude, longitude], {
            icon: getIconMarker(event.eventType),
            clickable: true,
            zIndexOffset: -1
        });

        contentPopup = getContentPopup(event);

        marker.bindPopup(contentPopup, {
            offset: point
        });

        marker.on("mouseover", function () {

            var position = this.getLatLng();
            var points = [position.lat, position.lng];

            this.accuracy = this.accuracy || 0;

            var radius = new L.Circle(points, this.accuracy);

            radius.kindParent = "HOS";
            radius.hosType = "radiusHOS";

            radiusLayer = radius;

            map.addLayer(radius);

        });

        marker.on("mouseout", function () {

            if (radiusLayer !== null) {

                map.removeLayer(radiusLayer);

            }

        });

        marker.eventId = event.id;
        marker.accuracy = accuracy;
        marker.hosType = eventType;
        marker.kindParent = "HOS";

        map.addLayer(marker);

    };

    this.verifyDate = function(inputDate) {
        const eventDate = Monet.Format.DateTime.parse(inputDate).getTime();
        let beginDateInput, endDateInput;

        if (Monet.Utils.GetTabName() === 'HosMapDisplay'){
            beginDateInput = document.querySelector(`${selector} #HOS_beginDate input`);
            endDateInput = document.querySelector(`${selector} #HOS_endDate input`);
        }
        else if (Monet.Utils.GetTabName().includes('RouteDetails_')){
            beginDateInput = document.querySelector(`${selector} input[name='routePlay_initialDate']`);
            endDateInput = document.querySelector(`${selector} input[name='routePlay_finalDate']`);
        }

        const beginDate = beginDateInput ? Monet.Format.DateTime.parseLocale(beginDateInput.value).getTime() : 0;
        const endDate = endDateInput ? Monet.Format.DateTime.parseLocale(endDateInput.value).getTime() : 0;

        return (eventDate >= beginDate && endDate >= eventDate);
    };

    this.drawMarkers = function (hosCollection, map, fitBounds, action) {

        var error         = null,
            modelsHos     = null,
            modelLenth    = null,
            layerControl  = null,
            events        = null,
            typeIsChecked = false,
            points        = [],
            event         = {};


        try {

            if (map && hosCollection.models) {

                modelsHos = hosCollection.models;
                modelLenth = modelsHos.length;

                layerControl = new Greenmile.Toolbar.Map.HOSLayerControl(selector + ' #mapCon');

                for (var i = 0; i < modelLenth; i++) {

                    events = modelsHos[i].get("events");

                    for (var j = 0; j < events.length; j++) {

                        event = events[j];

                        if (event.latitude && event.longitude) {

                            points.push([event.latitude, event.longitude]);

                            //se o tipo tiver marcado e for update
                            if (action === "update" || typeof action === 'undefined') {

                                typeIsChecked = layerControl.eventTypeIsChecked(event.eventType);

                                if (typeIsChecked) {

                                    this.removeHosOnMap(map, undefined, event.id);

                                    if (this.verifyDate(event.eventTime)) {
                                        drawMarker(event, map);
                                    }
                                    

                                }

                            } else if (layerControl.checkDrawHOSOnMapPreferenceUser(event.eventType) && this.verifyDate(event.eventTime)) {
                                drawMarker(event, map);
                            }
                        }
                    }
                }

                if (fitBounds && points.length > 0) {
                    map.fitBounds(points);
                }

            } else {

                error = new Monet.Exception.ReturnError(this,
                    "Parametters is undefined on format and draw markers by model");
                error.console();

            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on draw marker by cluster", e);
            error.console();
        }

    };

    this.removeHosOnMap = function (map, hosType, eventId) {

        var error  = null,
            layers = map._layers;

        try {

            for (var i in layers) {

                if (hosType && layers[i].hosType && layers[i].hosType === hosType) {

                    map.removeLayer(layers[i]);

                } else if (eventId && layers[i].kindParent && layers[i].eventId === eventId) {

                    map.removeLayer(layers[i]);

                }

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on remove HOS on map", e);
            error.console();

        }
    };

    this.drawMarkersByType = function (hosCollection, map, hosType) {

        var error      = null,
            modelsHos  = null,
            modelLenth = null,
            events     = null,
            event      = {},
            eventType  = "",
            utils      = Greenmile.HoursOfService.Utils;
        
        try {

            if (map && hosCollection.models) {

                modelsHos = hosCollection.models;
                modelLenth = modelsHos.length;

                this.removeHosOnMap(map, hosType);

                for (var i = 0; i < modelLenth; i++) {
 
                    events = modelsHos[i].get("events");

                    for (var j = 0; j < events.length; j++) {

                        event = events[j];
                        eventType = utils.getEventTypeName(event.eventType);

                        if (event.latitude && event.longitude && eventType === hosType && this.verifyDate(event.eventTime)) {

                            drawMarker(event, map, hosType);

                        }

                    }

                }

            } else {

                error = new Monet.Exception.ReturnError(this,
                    "Parametters is undefined on format and draw markers on cluster by type");
                error.console();

            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on draw marker on cluster by type", e);
            error.console();
        }

    };

    /**
     * Método para centralizar o marker no mapa.
     * @param {Object} bounds: objeto contendo a latitude e longitude
     */

    this.showMarkerSelected = function (bounds, namespaceOfScreen) {

        var error = null;

        try {
            var map       = null;

            if (bounds && namespaceOfScreen) {

                const points = [bounds.latitude, bounds.longitude];

                map = namespaceOfScreen.map;
                map.setView(points, map.getMaxZoom());
                //cria a função que limpa todos os timeouts desse mapa
                var clearAllTimeout = function () {

                    var timeOuts = namespaceOfScreen.timeoutLayerFocus;

                    for (var key in timeOuts) {
                        clearTimeout(timeOuts[key]);
                        timeOuts.splice(key, 1);
                    }

                    namespaceOfScreen.timeoutLayerFocus = timeOuts;
                };

                var dismissFocus = function () {
                    map.removeLayer(namespaceOfScreen.layerFocus);
                    clearAllTimeout();
                };

                if (typeof (namespaceOfScreen.layerFocus) !== "undefined") {
                    dismissFocus();
                }

                const radiusSize = 40;
                var radius = new L.Circle(points, bounds.accuracyMeters || radiusSize);
                radius.kindParent = "HOS";
                radius.kind = "radiusHOS";

                map.addLayer(radius);

                namespaceOfScreen.layerFocus = radius;

                var timeout = setTimeout(function () {
                    dismissFocus();
                }, 4000);

                if (!namespaceOfScreen.timeoutLayerFocus) {
                    namespaceOfScreen.timeoutLayerFocus = [];
                }

                namespaceOfScreen.timeoutLayerFocus.push(timeout);

            }


        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on show marker selected", e);
            error.console();
        }
    };

};
